import type {
  MyEntitlements,
  ProPlan,
  ProSubscriptionStatus,
  ProSubscriptionSummary,
} from '@/shared/domain'
import type { ProPaywallPanel } from './types'

export const WU_BUNDLE_PLAN: ProPlan = 'bb_pro_wu_annual'

const ACTIVE_STATUSES: ProSubscriptionStatus[] = ['trialing', 'active', 'paused', 'past_due']

export function hasActiveProRail(subscription: ProSubscriptionSummary | null): boolean {
  if (subscription === null || subscription.rail === null || subscription.plan === null) {
    return false
  }
  return subscription.status !== null && ACTIVE_STATUSES.includes(subscription.status)
}

export function hasOrgGrantedProAccess(entitlements: MyEntitlements | null): boolean {
  return (
    entitlements !== null &&
    entitlements.proAccess &&
    entitlements.proAccessSource === 'org_membership'
  )
}

export function selectProPaywallPanel(
  subscription: ProSubscriptionSummary | null,
): ProPaywallPanel {
  if (!hasActiveProRail(subscription) || subscription === null) return 'buy'
  if (subscription.plan === WU_BUNDLE_PLAN) return 'bundled'
  return subscription.rail === 'iap' ? 'iap-managed' : 'stripe-upgrade'
}

export function upgradeBlockedReason(
  subscription: ProSubscriptionSummary | null,
): string | null {
  if (subscription === null) return null
  if (subscription.status === 'past_due') {
    return 'Your last payment did not go through. Update your payment method before upgrading.'
  }
  if (subscription.pendingPlan !== null) {
    return 'You already have a plan change scheduled. Cancel it before upgrading.'
  }
  return null
}
